import { Box, Button, DialogActions, DialogContent, Stack, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Translate from "../../utils/Translate";
import AutocompleteSearchField from "../AutocompleteSearchField";
import { useState } from "react";
import { useApi } from "../../utils/Api";

export default function MultiPartChildForm({ currentPart, currentChildPartQty, onCancel, onOk }) {
  const [part, setPart] = useState(currentPart);
  const [childPartQty, setChildPartQty] = useState(currentChildPartQty ?? 1);
  const api = useApi();

  function handlePartSelected(selectedPart) {
    setPart(selectedPart);
  }

  return (
    <>
      <DialogContent>
        <Stack direction="column" spacing={3} marginTop={1}>
          <AutocompleteSearchField
            disabled={!!currentPart}
            label={Translate.get("PartLabel")}
            value={part ?? ""}
            groupBy={(option) => Translate.getPartTypePlural(option.partType)}
            onValueChange={(selectedPart) => handlePartSelected(selectedPart)}
            getOptionLabel={(option) => option?.description ?? ""}
            renderOption={(option) => (
              <Grid container>
                <Grid size={3}>
                  <Typography
                    noWrap
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                    }}
                  >
                    {option.partNo ?? ""}
                  </Typography>
                </Grid>
                <Grid size={9}>
                  <Box>{option.description}</Box>
                </Grid>
              </Grid>
            )}
            keyPropName="partId"
            disableAddAsNew={true}
            requireSelection={true}
            search={async (searchText) => {
              const results = await partSearch(searchText, api);
              // Sorting needed for groupBy of search results
              return results.sort((a, b) => {
                const partTypeSort = Translate.getPartTypePlural(a.partType).localeCompare(
                  Translate.getPartTypePlural(b.partType),
                );
                if (partTypeSort != 0) {
                  return partTypeSort;
                } else if (a.partNo && b.partNo) {
                  return !isNaN(a.partNo) && !isNaN(b.partNo)
                    ? Number(a.partNo) - Number(b.partNo)
                    : a.partNo.localeCompare(b.partNo);
                } else if (a.partNo) {
                  return 1;
                } else if (b.partNo) {
                  return -1;
                } else {
                  return a.description.localeCompare(b.description);
                }
              });
            }}
            textFieldProps={{
              autoFocus: true,
              required: true,
              error: false,
              helperText: "",
            }}
          />
          {part && (
            <TextField
              required
              fullWidth
              value={childPartQty ?? ""}
              InputProps={{ spellCheck: false }}
              onChange={(event) => setChildPartQty(event.target.value)}
              label={Translate.get("Quantity")}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                type: "number",
                min: 1,
              }}
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{Translate.get("Cancel")}</Button>
        <Button disabled={!part || !childPartQty} onClick={() => onOk(part, childPartQty)} variant="contained">
          Ok
        </Button>
      </DialogActions>
    </>
  );
}

async function partSearch(searchText, api) {
  const response = await api.fetch(
    `${import.meta.env.VITE_MAIN_URL}warehouse/parts/search?q=${searchText}&onlySellable=true`,
    false,
    "GET",
  );
  if (response.isSuccessful) {
    return response.parts;
  }
}
